import type { DemoSection } from "@/types/demo";

export const DEMO_SECTIONS: DemoSection[] = [
  {
    id: "s1",
    title: "Tes Wawasan Kebangsaan",
    durationMinutes: 5,
    passingGrade: 60,
    questions: [
      {
        id: "q1",
        text: "Pancasila sebagai dasar negara Indonesia pertama kali dirumuskan dalam sidang BPUPKI oleh?",
        explanation:
          'Ir. Soekarno menyampaikan rumusan Pancasila pada 1 Juni 1945 dalam sidang BPUPKI (Badan Penyelidik Usaha-usaha Persiapan Kemerdekaan Indonesia). Pidato ini dikenal sebagai pidato "Lahirnya Pancasila". Meskipun Muhammad Yamin dan Soepomo juga menyampaikan gagasan tentang dasar negara, rumusan Pancasila yang kita kenal saat ini berasal dari pidato Soekarno.',
        type: "multiple_choice",
        options: [
          { key: "A", text: "Ir. Soekarno", isCorrect: true },
          { key: "B", text: "Mohammad Hatta", isCorrect: false },
          { key: "C", text: "Soepomo", isCorrect: false },
          { key: "D", text: "Muhammad Yamin", isCorrect: false },
        ],
      },
      {
        id: "q2",
        text: "UUD 1945 pertama kali disahkan pada tanggal?",
        explanation:
          "UUD 1945 disahkan oleh PPKI (Panitia Persiapan Kemerdekaan Indonesia) pada tanggal 18 Agustus 1945, sehari setelah Proklamasi Kemerdekaan (17 Agustus 1945). Pada sidang ini juga ditetapkan Soekarno sebagai Presiden dan Mohammad Hatta sebagai Wakil Presiden pertama Republik Indonesia.",
        type: "multiple_choice",
        options: [
          { key: "A", text: "17 Agustus 1945", isCorrect: false },
          { key: "B", text: "18 Agustus 1945", isCorrect: true },
          { key: "C", text: "1 Juni 1945", isCorrect: false },
          { key: "D", text: "22 Juni 1945", isCorrect: false },
        ],
      },
      {
        id: "q3",
        text: "Semboyan Bhinneka Tunggal Ika berasal dari kitab?",
        explanation:
          'Bhinneka Tunggal Ika ("Berbeda-beda tetapi tetap satu") berasal dari Kitab Sutasoma karya Mpu Tantular yang ditulis pada masa Kerajaan Majapahit (abad ke-14). Kalimat lengkapnya adalah "Bhinneka Tunggal Ika tan hana dharma mangrwa" yang artinya "Berbeda-beda tetapi tetap satu, tidak ada kebenaran yang mendua". Semboyan ini kemudian diadopsi sebagai semboyan negara Indonesia.',
        type: "multiple_choice",
        options: [
          { key: "A", text: "Negarakertagama", isCorrect: false },
          { key: "B", text: "Sutasoma", isCorrect: true },
          { key: "C", text: "Pararaton", isCorrect: false },
          { key: "D", text: "Arjunawiwaha", isCorrect: false },
        ],
      },
    ],
  },
  {
    id: "s2",
    title: "Tes Intelegensi Umum",
    durationMinutes: 5,
    passingGrade: 60,
    questions: [
      {
        id: "q4",
        text: "Jika semua kucing adalah hewan, dan beberapa hewan berkaki empat, maka?",
        explanation:
          'Ini adalah soal logika silogisme. Premis 1: Semua kucing adalah hewan. Premis 2: Beberapa hewan berkaki empat. Dari kedua premis ini, kita tidak bisa menyimpulkan bahwa SEMUA kucing berkaki empat, karena premis kedua hanya menyatakan "beberapa" hewan. Kesimpulan yang valid adalah "Beberapa kucing MUNGKIN berkaki empat" — kemungkinan ada karena kucing termasuk hewan, dan beberapa hewan berkaki empat.',
        type: "multiple_choice",
        options: [
          { key: "A", text: "Semua kucing berkaki empat", isCorrect: false },
          {
            key: "B",
            text: "Beberapa kucing mungkin berkaki empat",
            isCorrect: true,
          },
          {
            key: "C",
            text: "Tidak ada kucing berkaki empat",
            isCorrect: false,
          },
          { key: "D", text: "Semua hewan adalah kucing", isCorrect: false },
        ],
      },
      {
        id: "q5",
        text: "12, 15, 21, 30, 42, ... Bilangan selanjutnya adalah?",
        explanation:
          "Perhatikan selisih antar bilangan: 15-12=3, 21-15=6, 30-21=9, 42-30=12. Selisihnya membentuk pola kelipatan 3: yaitu 3, 6, 9, 12, ... Maka selisih berikutnya adalah 15. Sehingga bilangan selanjutnya: 42 + 15 = 57.",
        type: "multiple_choice",
        options: [
          { key: "A", text: "55", isCorrect: false },
          { key: "B", text: "57", isCorrect: true },
          { key: "C", text: "54", isCorrect: false },
          { key: "D", text: "60", isCorrect: false },
        ],
      },
      {
        id: "q8",
        text: "Perhatikan gambar berikut. Berdasarkan diagram, bagian yang diarsir menunjukkan irisan dari himpunan A dan B. Manakah pernyataan yang benar?",
        image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 180"><rect width="320" height="180" fill="#f8f9fa" rx="12"/><text x="160" y="22" text-anchor="middle" font-size="13" font-weight="bold" fill="#444">Diagram Venn</text><circle cx="120" cy="100" r="60" fill="rgba(74,144,217,0.15)" stroke="#4A90D9" stroke-width="2"/><circle cx="200" cy="100" r="60" fill="rgba(231,76,60,0.15)" stroke="#E74C3C" stroke-width="2"/><path d="M160,56 a60,60 0 0,1 0,88 a60,60 0 0,1 0,-88" fill="rgba(142,68,173,0.3)"/><text x="95" y="105" text-anchor="middle" font-size="16" font-weight="bold" fill="#4A90D9">A</text><text x="230" y="105" text-anchor="middle" font-size="16" font-weight="bold" fill="#E74C3C">B</text><text x="160" y="105" text-anchor="middle" font-size="13" font-weight="bold" fill="#8E44AD">A∩B</text></svg>')}`,
        explanation:
          "Diagram Venn menunjukkan dua himpunan A dan B yang saling beririsan. Bagian yang diarsir (tengah) adalah irisan A∩B, yaitu elemen yang termasuk di kedua himpunan sekaligus. Elemen di area ini termasuk anggota A DAN anggota B.",
        type: "multiple_choice",
        options: [
          {
            key: "A",
            text: "Semua elemen A adalah elemen B",
            isCorrect: false,
          },
          {
            key: "B",
            text: "Bagian yang diarsir berisi elemen yang hanya ada di A",
            isCorrect: false,
          },
          {
            key: "C",
            text: "Bagian yang diarsir berisi elemen yang ada di A dan B",
            isCorrect: true,
          },
          {
            key: "D",
            text: "Himpunan A dan B tidak memiliki elemen yang sama",
            isCorrect: false,
          },
        ],
      },
    ],
  },
  {
    id: "s3",
    title: "Penalaran Figural",
    durationMinutes: 3,
    passingGrade: 60,
    questions: [
      {
        id: "q6",
        text: "Perhatikan pola berikut. Manakah gambar yang melanjutkan deret?",
        image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 100"><g transform="translate(20,10)"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="8" fill="#4A90D9"/></g><g transform="translate(110,10)"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2" transform="rotate(22.5,40,40)"/><circle cx="40" cy="40" r="8" fill="#4A90D9"/></g><g transform="translate(200,10)"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2" transform="rotate(45,40,40)"/><circle cx="40" cy="40" r="8" fill="#4A90D9"/></g><g transform="translate(290,10)"><text x="40" y="48" text-anchor="middle" font-size="36" fill="#999">?</text></g></svg>')}`,
        explanation:
          "Pola menunjukkan rotasi persegi 22.5° searah jarum jam per langkah, sementara lingkaran biru tetap di tengah. Langkah berikutnya: rotasi 67.5°.",
        type: "multiple_choice",
        options: [
          {
            key: "A",
            text: "",
            isCorrect: true,
            image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2" transform="rotate(67.5,40,40)"/><circle cx="40" cy="40" r="8" fill="#4A90D9"/></svg>')}`,
          },
          {
            key: "B",
            text: "",
            isCorrect: false,
            image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2" transform="rotate(90,40,40)"/><circle cx="40" cy="40" r="8" fill="#E74C3C"/></svg>')}`,
          },
          {
            key: "C",
            text: "",
            isCorrect: false,
            image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="8" fill="#4A90D9"/></svg>')}`,
          },
          {
            key: "D",
            text: "",
            isCorrect: false,
            image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2" transform="rotate(45,40,40)"/><circle cx="40" cy="40" r="12" fill="#4A90D9"/></svg>')}`,
          },
        ],
      },
      {
        id: "q7",
        text: "Perhatikan pola berikut. Manakah gambar yang TIDAK termasuk kelompok?",
        image: `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 100"><g transform="translate(10,10)"><circle cx="40" cy="40" r="30" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="10" fill="#2ECC71"/></g><g transform="translate(100,10)"><circle cx="40" cy="40" r="30" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="10" fill="#2ECC71"/></g><g transform="translate(190,10)"><rect x="10" y="10" width="60" height="60" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="10" fill="#2ECC71"/></g><g transform="translate(280,10)"><circle cx="40" cy="40" r="30" fill="none" stroke="#333" stroke-width="2"/><circle cx="40" cy="40" r="10" fill="#2ECC71"/></g></svg>')}`,
        explanation:
          "Tiga gambar memiliki lingkaran luar, satu gambar memiliki persegi. Gambar C (persegi) adalah yang tidak termasuk kelompok.",
        type: "multiple_choice",
        options: [
          { key: "A", text: "Gambar 1", isCorrect: false },
          { key: "B", text: "Gambar 2", isCorrect: false },
          { key: "C", text: "Gambar 3", isCorrect: true },
          { key: "D", text: "Gambar 4", isCorrect: false },
        ],
      },
    ],
  },
];

export const EXAM_RULES_LIST: string[] = [
  "Ujian akan berjalan dalam mode layar penuh (fullscreen). Jangan keluar dari layar penuh selama ujian berlangsung.",
  'Waktu berjalan otomatis setelah menekan tombol "Mulai Ujian".',
  "Berpindah tab atau aplikasi lain akan mengurangi waktu 10 detik sebagai penalti.",
  "Jawaban dapat diubah selama waktu belum habis.",
  "Hasil akan langsung ditampilkan setelah ujian selesai.",
];
